import merge from "lodash/merge";
import omit from "lodash/omit";
import mapValues from "lodash/mapValues";
import superagentRequest from "superagent";
import config from "../config";
import logger from "../logger";
import querystring from "qs";

import { history } from "../util";

function makeUrl({ path, query }) {
  return `${config.endpoint}${path}?${querystring.stringify(
    Object.assign(query, {
      event_bucket: config.event_bucket,
      api_key: config.api_key
    })
  )}`;
}

let pendingRequests = {};

function request(opts, cb) {
  // If the exact same HTTP request is currently underway, just wait
  // for it to finish rather than starting a whole new one. This is a
  // kinda janky way to deal with re-renders/etc.
  let reqKey = JSON.stringify(opts);
  if (pendingRequests[reqKey]) {
    pendingRequests[reqKey].push(cb);
    return;
  } else {
    pendingRequests[reqKey] = [cb];
  }

  var qs = omit(opts.qs, k => k === null || k === undefined);
  qs = mapValues(qs, v => (typeof v === "object" ? JSON.stringify(v) : v));
  if (Object.keys(qs).length === 0) {
    qs = undefined;
  }

  let req = superagentRequest[opts.method.toLowerCase()](
    config.endpoint + (opts.endpoint || opts.path)
  );

  if (opts.json) {
    req.send(merge(opts.json, { event_bucket: config.event_bucket }));
  }

  if (qs) {
    req.query(qs);
  }

  req.auth(config.api_key);

  req.end(function(err, resp) {
    if (
      resp &&
      resp.body &&
      resp.body.error &&
      (resp.body.error.code || resp.body.error.message)
    ) {
      // Currently not logging API errors since they're being picked up on the backend anyways.
      // FIXME: Do we really want to stay like this?
      // let errorToLog = Object.assign({}, resp.error, {
      //   error_source: 'api-response-error',
      //   request: opts
      // });
      // logger.info(errorToLog);

      // Redirect to login page for invalid credentials
      if (
        !opts.ignoreLoginErrors &&
        resp.body.error.code === "InvalidCredentials" &&
        window.location.href.indexOf("login") === -1 &&
        window.location.href.indexOf("accept_transfer") === -1
      ) {
        // custom deep redirect for accept_transfer
        (window.EVENTIVE_EVERYWHERE_HISTORY || history).push({
          pathname: "/login",
          query: {
            next: "back"
          },
          state: {
            fromApiLoginError: true,
            error: resp.body.error
          }
        });
      }

      (pendingRequests[reqKey] || [cb]).forEach(
        cb => cb && cb(resp.body.error)
      );
      delete pendingRequests[reqKey];
      return;
    }

    (pendingRequests[reqKey] || [cb]).forEach(
      cb => cb && cb(err, resp && resp.body)
    );
    delete pendingRequests[reqKey];
  });
}

export default {
  makeUrl,
  request
};



// WEBPACK FOOTER //
// ./src/app/utils/api.js